<template>
  <v-tab :to="route">
    <v-icon left>
      {{ icon }}
    </v-icon>
    <span>{{ label }}</span>
  </v-tab>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    route: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style></style>
